import { TemporalEntityId } from 'entities-next/common'
import React, { useRef } from 'react'
import { makeStyles } from 'tss-react/mui'
import { useMatchParams } from 'utils-next/routes'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Card, Divider, Theme } from '@mui/material'

import { CorporateDetailsViewProvider } from './CorporateDetailsView.store'
import { CorporateDetailsViewContent } from './CorporateDetailsViewContent.component'
import { CorporateDetailsViewHeader } from './CorporateDetailsViewHeader.component'

export type CorporateDetailsViewProps = ExtendableStyles & Testable

export function CorporateDetailsView() {
  const { classes } = useStyles()
  const actionBarRef = useRef<any>(null)
  const { id } = useRouteVariables()
  return (
    <CorporateDetailsViewProvider corporateId={id} actionBarRef={actionBarRef}>
      <Card className={classes.content}>
        <CorporateDetailsViewHeader className={classes.header} />
        <Divider />
        <CorporateDetailsViewContent />
      </Card>
      <div className={classes.footer} ref={actionBarRef} />
    </CorporateDetailsViewProvider>
  )
}

function useRouteVariables() {
  const { corporateId = '' } = useMatchParams<{ corporateId: string }>()
  const id = Number(corporateId)
  if (isNaN(id)) {
    return {
      id: TemporalEntityId.new,
    }
  } else {
    return {
      id: id,
    }
  }
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minHeight: spacing(50),
  },
  header: {
    position: 'relative',
    width: '100%',
    height: spacing(12),
  },
  footer: {
    position: 'relative',
    paddingTop: spacing(3),
    paddingBottom: spacing(2),
    width: '100%',
    bottom: 0,
    right: 0,
  },
}))
